import { render, staticRenderFns } from "./RipaOverridePii.vue?vue&type=template&id=6f964694"
import script from "./RipaOverridePii.vue?vue&type=script&lang=js"
export * from "./RipaOverridePii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports